// extracted by mini-css-extract-plugin
export default {"scrollBody":"wm5WoYqO"};